import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../../ui/table";
import { SaasGrant } from "../shared/saasTypes";
import { formatDate, humanize } from "../shared/saasFormat";
import { PermissionBadge } from "../shared/SaasUi";

export default function GrantsTable({ grants, mode, onIdentity }: {
    grants: SaasGrant[];
    mode: "identity" | "resource";
    onIdentity?: (login: string) => void;
}) {
    if (grants.length === 0) {
        return <p className="text-sm text-muted-foreground py-6 text-center">No access grants recorded</p>;
    }
    return (
        <div className="cloud-table-card cloud-card-surface overflow-x-auto">
            <Table>
                <TableHeader>
                    <TableRow>
                        <TableHead>{mode === "identity" ? "Resource" : "Identity"}</TableHead>
                        {mode === "identity" && <TableHead>Type</TableHead>}
                        <TableHead>Permission</TableHead>
                        <TableHead>Granted via</TableHead>
                        <TableHead>Expires</TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {grants.map((grant, index) => (
                        <TableRow
                            key={`${grant.identityLogin}-${grant.resourceExternalId}-${grant.source}-${index}`}
                            className={mode === "resource" && onIdentity ? "cursor-pointer" : undefined}
                            onClick={mode === "resource" && onIdentity ? () => onIdentity(grant.identityLogin) : undefined}
                        >
                            <TableCell className="text-xs font-medium max-w-xs truncate" title={mode === "identity" ? grant.resourceFullName : grant.identityLogin}>
                                {mode === "identity" ? grant.resourceFullName : grant.identityLogin}
                            </TableCell>
                            {mode === "identity" && <TableCell className="text-xs">{humanize(grant.resourceType)}</TableCell>}
                            <TableCell className="text-xs">
                                <PermissionBadge level={grant.permission} label={grant.rawPermission} />
                            </TableCell>
                            <TableCell className="text-xs text-muted-foreground">
                                {humanize(grant.source)}
                                {grant.sourceName ? ` · ${grant.sourceName}` : ""}
                            </TableCell>
                            <TableCell className="text-xs text-muted-foreground">{formatDate(grant.expiresAt, "Never")}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </div>
    );
}
